import { render, staticRenderFns } from "./ytSearchSetting.vue?vue&type=template&id=21af770e&"
import script from "./ytSearchSetting.vue?vue&type=script&lang=js&"
export * from "./ytSearchSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports